import React, { Component } from 'react'
import styled from 'styled-components'

class PrivacyAgreementJa extends Component {
  state = {
    content: `隐私声明
    引言

    更新日期：2021年08月16日
    公司信息
    公司名称：天津九安医疗电子股份有限公司
    注册地址：天津市南开区雅安道金平路3号
    联系电话：022-87611660

    天津九安医疗电子股份有限公司深知个人信息对您的重要性，并会尽全力保护您的个人信息安全。在您使用共同照护APP时，我们恪守以下原则，保护您的个人信息：权责一致、目的明确、选择同意、最少够用、确保安全、主体参与、公开透明。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
    请您在使用我们的产品或服务前，请您仔细阅读本隐私政策的全部条款，以便您了解共同照护使用您个人信息的目的、范围、方式等。一旦您开始使用共同照护产品或服务，即表示您以充分理解并同意本政策。如果您为儿童，则请您在法定监护人陪同下审阅本隐私政策，经法定监护人审阅并同意后，您方可使用共同照护并向天津九安医疗电子股份有限公司提供个人信息。如果您或者监护人不同意本隐私政策任何内容，您应立即停止使用共同照护的产品或服务。当您使用共同照护提供的任一服务时，即表示您已同意我们按照本隐私政策来收集、使用、存储和保护您的相关信息。

    天津九安医疗电子股份有限公司（以下简称"共同照护"或"我们"）非常重视您的个人信息，并让您对个人信息拥有控制权，我们会使用强大的加密技术来保护您的隐私，同时制定严格的政策来管理所有数据。当您访问共同照护时，或使用我们提供的服务前，您需要同意本政策中关于我们如何收集、使用、储存和分享您的相关信息的规定。如果您不同意本隐私政策中的任何内容，请立即停止使用或访问我们的产品和服务，其中一切商业行为与医院无任何关系。
    本隐私权政策旨在协助您了解我们会收集哪些信息、为什么收集这些信息，以及您如何更新、管理、导出和删除自己的信息，若您对本政策有任何问题，请联系：help@ihealthlabs.com.cn。

    术语
    Cookie：Cookie 是包含字符串的小文件，会在您访问网站时发送到您的计算机上。当您再次访问网站时，Cookie 使该网站可以识别您的浏览器。Cookie 还能存储用户使用偏好及其他信息。您可以重置您的浏览器拒绝所有的 Cookie，或者在发送 Cookie 时提示。但如果没有 Cookie，某些网站功能或服务可能无法正常工作。
    应用数据缓存：应用数据缓存是指设备上的一种数据存储机制。使用它有很多好处，例如，可让网络应用在未连接互联网的情况下运行，以及可通过提高内容加载速度来改善相关应用的性能。
    个人信息：用户向我们提供的、可用于识别用户的个人身份的信息，例如姓名、电话号码、身份证号码、住址、通讯记录等信息，或我们可以正当地通过链接找到此类信息的其他数据。
    IP地址：每台连接到互联网的计算机都指定了唯一的编号，称为互联网协议 (IP) 地址。由于这些编号通常都是根据国家/地区的区域指定的，因此 IP 地址通常可用于识别计算机连接至互联网时所在的国家/地区。

    一、我们如何搜集和使用您的信息？
    1. 我们如何搜集您的信息？
    当您使用共同照护的产品或服务提供的问照护功能时，在问诊过程中，我们可能会申请开启您的相机或相册权限（图片传输）、麦克风（语音）以及存储的相关权限；同时可能要求您提供病症、病历、住院记录、检验报告、手术及麻醉记录、护理记录、用药记录、药物食物过敏信息、生育信息、以往病史、诊治情况、家族病史、现病史、既往史、传染病史及其它个人健康生理信息，以及个人健康相关数据，例如体重、身高和其它相关信息，此类信息将用于患者疾病管理。另外，我们可能会收集您在使用共同照护服务或产品过程中产生的健康咨询详情（如文字、图片、视频、语音等）、预约挂号记录、检查检验报告、用药处方、病历处方、院外血糖监测记录、院外血压监测记录、院外饮食记录、院外用药记录等信息，用于向您展示及便于您对信息进行管理。
    1.1 您提供的信息
    1.1.1 您在注册账户或使用我们的服务时，向我们提供相关个人信息，例如您的姓名、电话号码、性别、出生年月等信息。如果您想充分使用我们提供的各种分享功能，可能还需要创建公开显示的个人资料，其中可能会包含您的姓名和照片。
    1.1.2 您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时上传、提交、存储、发送或接收的信息。
    1.2 您在使用服务过程中，我们获取的权限
    我们会收集您使用的服务以及使用方式的信息，如您何时在共同照护 App上传了饮食照片，何时上传了您的血糖测量值，或何时查看了我们的视频和文章。此类信息包括：

    1.2.1 蓝牙权限
    您在使用共同照护产品进行血糖和血压测量时，我们需要开启您设备的蓝牙权限以便于血糖仪和血压计的连接、数据的传输和读取，包括血糖（血压）的测量结果数据和测量时间，以便于收集用户的疾病管理情况和效果。

    1.2.2 麦克风权限
    您在使用共同照护产品进行医患沟通的信息传输时，我们需要开启您设备的麦克风权限以便于语音内容的传输和读取，以便于收集用户的疾病管理情况和效果。

    1.2.3 通知权限
    您在使用共同照护产品或服务的过程中，我们可能有关于您的消息、动态或广告进行推送，我们需要开启您设备的通知权限以便于消息、动态或广告的推送和收取，以达到通知用户的目的。

    1.2.4 无线网络的使用权限
    您在使用共同照护产品或服务过程中，我们需要开启您的无线网络权限以便于数据和信息的传输、存储和更新。

    1.2.5 设备信息
    设备信息：为识别您的设备并提供服务安全性，我们会收集设备信息，包括设备品牌、设备制造商、系统版本号、设备序列号、剪切板数据、设备MAC地址、BSSID（无线接入点标识）、SSID（无线网络名称）、软件安装列表。其中，BSSID 与 SSID 用于识别您所处的无线网络环境，以便于保障服务正常运行、进行安全风控及改善网络连接体验。

    1.2.6 相册权限
    为了给您提供全方位的管理血糖服务体验，经过您的授权，我们的服务器会提取您设备中的视频、图片、软件名、版本号等，并通过加密上传到服务器进行比对，用于匹配与该视频、图片、软件相对应的显示功能。

    1.2.7 位置信息
    您可以授权开启设备的定位功能，并使用我们基于地理位置提供的相关服务，当然您也可以通过关闭定位功能，随时停止我们对您的地理位置的收集，同时我们将停止基于地理位置提供的相关服务。

    1.2.8 订单信息
    您可以在APP平台中提交订单，购买物品，提交买卖信息，此买卖活动和医院无任何关系。

    1.2.9 性别信息
    为了给您提供恰当的管理服务，我们需要收集您的性别信息，我们会使用您给我们的性别作为管理依据，给您提供正确的管理方案，并且性别信息不会让应用内的其他用户知晓，该信息只用于管理服务。

    1.2.10 年龄信息
    在进行健康咨询服务时，我们需要知道您的年龄，以便在进行管理服务时，提供符合您年龄的管理方案。该信息不会让应用内的其他用户知晓，并且只用于管理服务。

    1.2.11 已安装APP信息
    在您进行登录时，我们提供了多种登录方式，其中包括微信登录，所以在您登录时，我们会判断您的设备中是否安装了微信，进而您可以使用微信账号授权登录共同照护App

    2.我们如何使用您的信息
    我们可能将上述收集的信息用作以下用途：
    2.1 注册账户信息，您需要注册一个账户，以便于我们为您提供服务。当您注册时，请您至少提供手机号码，我们将通过发送短信验证码的方式验证您的身份是否有效。

    2.2 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；

    2.3 帮助我们设计新服务，改善我们现有服务；

    2.4 使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应

    2.5 执行软件验证、升级服务；

    2.6 其他有利于用户和共同照护运营者利益且不违反任何强制性法律法规的情况。

    2.7 让您参与有关我们产品和服务的调查

    2.8 让您能正常在共同照护产品中进行购买服务。
    当您在共同照护产品中的照护商城购买商品时，我们会收集您的交易信息和记录，包括您所购买的商品、具体订单号、订单创建时间和您应支付的金额，我们收集这些信息时为了帮助您顺利完成交易、保障您的交易安全和方便您查询订单信息。其中，如果您购买的是实体商品，在下单过程中，您需至少提供收货人的姓名、收货地址、收货人联系电话，如果您通过照护商城为他人订购商品时，同样需要提供该实际收货人的前述个人信息，且需确保您已经取得其授权同意。

    2.9 让您能正常完成商品的支付
    为完成您所订购的商品或服务的支付，您需要提供微信或支付宝的支付账户与支付信息（用于分辨是否在微信或支付宝完成支付过程），同时为了满足相关法律法规或监管机构的要求，我们可能需要将您必要的个人信息及上述支付信息提供给监管机构以及监管机构指定的第三方服务机构，以顺利完成您所购买的服务或商品费用的支付和结算，如您不提供上述信息，将无法正常使用相关的支付功能，但不影响您使用共同照护进行基本的浏览商品或服务功能。

    2.10 让您能正常的查看商品物流状态
    为了将您在共同照护产品中的照护商城所购买商品顺利运送到收货人所在，您需提供收货人的姓名、收货地址、收货人联系电话。您知晓并同意第三方物流配送主题不可避免地获知及使用您上述信息，用于完成交付目的。为使我们及时获悉并确认交付进度及状态，向您提供售后及争议解决服务，您同意我们可自第三方物流相关服务主体处收集与交付进度相关的信息。

    2.11 让我们能为您提供正确恰当的管理服务
    在进行健康咨询、饮食点评等管理服务时，您需要提供您的性别、出生年月，让我们能针对性的提供管理和服务，并且保证管理服务的内容和方式是恰当的。

    3.我们承诺
    3.1 我们不会根据敏感类别（例如种族、宗教、性取向或健康状况）向您展示个性化内容；

    3.2 在任何时候、任何情况下都不会向任何第三方出售您的个人信息，我们只会在法律允许的范围内使用根据本协议获得的信息。我们会制定严格的政策保护您的个人信息，除非事先获得您的授权或本声明另有规定之外，不会将您的这些信息对外公开或向第三方提供。

    3.3 当您通过电话与我们联系时，我们可能会保存您的通信和通话的记录和内容，包括您所留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录解决问题的处理方案及结果。为了提供服务及改进服务质量的合理需要，我们还可能使用您的其他相关信息，包括您与医护团队联系时您所提供的相关信息、您参与问卷调查时向我们发送的问卷答复信息。

    4.与第三方公司合作
    4.1我们会要求关联公司及合作单位按照我们的说明、隐私政策以及任何其他适当的保密和安全措施来保证您的个人信息安全。除此之外，我们不会向任何第三方提供或分享您的信息。

    5.我们不会将您的个人信息转移或披露给任何非关联的第三方，除非：
    5.1在共享、转让、公开或披露个人信息时，获得您明确同意或您的授权后；

    5.2与国家安全、国防安全直接相关的；

    5.3在法律、法律程序、诉讼或政府部门强制性要求的情况下，我们可能会公开或披露您的个人信息；

    5.4与刑事侦查、起诉、审判和判决执行等直接相关的；

    5.5出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；

    5.6个人信息主体自行向社会公众公开的个人信息；

    5.7在完成合并、分立、收购或资产转让，我们可能会公开或披露您的个人信息；

    5.8与个人信息控制者履行法律法规规定的义务相关的；

    5.9从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；

    5.10以学术研究或公共利益为目的；

    5.11我们认为必要且不违反法律强制性规定的其他情形。

    6.隐私声明
    除非经过您的同意，否则我们不会向任何人提供您的敏感个人信息。


    二、如何更新、变更、导出、删除、注销您的信息
    1. 您在使用我们的产品和服务时，会被要求提供您真实的个人信息，您应当对您所提供信息的真实性、合法性、有效性及完整性负责，并及时更新和维护您的个人信息，以保证信息的真实、合法和有效。您可以随时管理您的个人信息，例如您的个人账户注册信息。

    2. 您可以自行从共同照护账号中删除您的内容或个人信息，或要求我们删除或修改信息，例如您想要删除个人帐户，可以发送邮件到help@ihealthlabs.com.cn与我们联络并提出您的要求。

    3. 在有些情况下，我们会出于法律目的或合法业务的需要将数据保留有限的一段时间。我们会尽力确保共同照护的服务能够保护信息免遭意外或恶意删除。因此，如果您删除了某些内容，我们可能会过一段时间才会从我们现用的和备用的系统中删除其副本。

    4. 您可以随时备份个人帐户名下的内容或将其用于非共同照护服务，您可以发邮件到help@ihealthlabs.com.cn与我们联络并提出您的要求。

    5. 如果您决定不再使用此账号，且需要清空您的账号信息，可点击“我的”-“设置”-“注销账号”进行操作，点击“注销账号后”，后台工作人员会对您的申请进行审核，工作人员通过客服和您联系确认后，会进行注销操作。账号注销后原账号内的所有数据均会清空，且无法再恢复。如有需要，可以重新注册并登录使用共同照护App。


    三、我们如何保护您的个人信息
    所有共同照护产品都内置了强大的安全功能，并且我们制定了严格的信息管理政策，配备专业的技术团队，采取了一系列合理的预防措施，以保护您的个人信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失，其中包括：
    （1）使用加密技术来确保您的数据在传输过程中保持私密性；
    （2）提供多种安全功能来协助您保护自己的帐号安全；
    （3）审查我们在收集、存储和处理信息方面的做法（包括实体安全措施），以防未经授权的人员访问我们的系统；
    （4）所有因提供服务而必须接触个人信息的共同照护 App员工、承包商和代理商等，都需要遵守合同中规定的严格保密义务，否则可将被处分或被解约。
    为了改善共同照护的产品或服务，向您及时通知应用内相关内容的变动，我们会通过APP向您推送必要的内容和相关通知。


    四、我们如何处理未成年人提供的个人信息
    我们非常重视未成年人信息的保护。我们只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为了保护未成年人而使用或披露有关未成年人的个人数据。"未成年人"的定义应考虑适用的法律以及各国家和地区的文化惯例。

    五、您分享的信息
    1. 我们会提供社交网络服务，您在使用这一类型服务时，您所上传或发布的信息（包括您公开的个人信息、您的通讯录、好友圈）、您对他人上传或发布的信息作出的回应，以及与这些信息有关的日志信息等，只要您不删除这些信息，它们会一直留存在公共领域，并被使用我们服务的其他用户分享、浏览。即使您删除这些信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或第三方在公共领域保存。
    2. 请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。您可以自行删除您上传、发布或分享的信息，如要求我们为您删除您的相关信息，请发送邮件到help@ihealthlabs.com.cn与我们联络并提出您的要求。

    六、数据传输
    1. 我们维护着架设于中国大陆的服务器，因此，我们处理您的信息时需要遵守所在国家或地区的数据保护法律，对您的数据和信息进行传输。
    2. 收到正式的书面投诉后，我们会与投诉方联系。我们会与服务器所在地的监管机构（包括当地的数据保护机构）合作，以解决任何与传输您的数据有关且无法由我们和您直接解决的投诉。

    七、第三方服务提供商
    为方便您的访问并丰富您的体验，可能会有第三方提供的产品或服务。您可以选择是否访问这类内容或链接，或是否使用该第三方的产品或服务。但我们对于第三方提供的产品或服务没有控制权。我们无法控制第三方掌握的您的任何个人信息。您在使用第三方产品或服务过程中的信息保护问题，不适用于本政策的管理。本政策也不适用于您自行选择提供给第三方的任何信息。请您查看该第三方的隐私保护政策。我们会以高度的保密义务对待您的信息，除非获得您的明确同意，我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，但经过处理无法识别特定个人且不能复原的除外，目前我们会在以下情形中，向您征求对共享您的个人信息的授权同意：
    （1）com.xiaomi.mipush(小米;小米推送)SDK、com.xiaomi.pushSDK：由小米科技有限责任公司提供技术支持，小米消息推送SDK收集您的外部存储状态、网络类型、设备制造商、设备制造国家、IMEI
    ANDROID_ID、IDFA、OpenUDID、IP 地址及推送状态，用于在小米、小米子品牌及小米合作商设备上接收消息推送，具体请见《小米帐号隐私政策》（https://static.account.xiaomi.com/html/privacy/account/zh_CN.html）；
    （2）com.huawei.hms(华为;华为推送) SDK：由华为软件技术有限公司提供技术支持，华为消息推送SDK收集您的外部存储状态，网络类型，设备制造商，设备制造国家，IMEI，ANDROID_ID，IDFA，OpenUDID，IP 地址及推送状态，用于在华为、华为子品牌及华为合作商设备上接收消息推送，具体请见《关于华为帐号与隐私的声明》（https://id1.cloud.huawei.com/AMW/v2/portal/agreements/accPrivacyStatement/index.html?lang=zh-cn&pageName=accPrivacyStatement&version=china&reqClientType=89&clientID=6099200&loginChannel=89000000）；
    （3）小米数据统计SDK：由小米科技有限责任公司提供技术支持，小米数据统计SDK收集您的设备制造商、设备制造国家、IMEI及ANDROID_ID，用于在产品中数据的收集和统计，具体请见《小米帐号隐私政策》（https://static.account.xiaomi.com/html/privacy/account/zh_CN.html）；
    （4）阿里云存储SDK：由阿里云计算有限公司提供技术支持，阿里云存储SDK收集您的网络类型、设备制造商、设备制造国家、IMEI及ANDROID_ID，用于在产品中信息和数据的存储和读取，具体请见《法律声明及隐私权政策》（https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201710161525_98396.html）
    （5）支付宝支付SDK：由支付宝(中国)网络技术有限公司提供技术支持，支付宝SDK收集您的手机状态、网络状态、读取写入外部储存，用于处理和缓存您的支付订单及支付状态，具体请见 《支付宝隐私权政策》（https://render.alipay.com/p/c/k2cx0tg8）；
    （6）微信开放平台SDK：由深圳市腾讯计算机系统有限公司提供技术支持（https://open.weixin.qq.com/），获取已安装APP信息用于支持微信授权登录，分享内容至微信以及进行微信支付，具体请见 《微信支付服务协议》（https://pay.weixin.qq.com/index.php/public/apply_sign/protocol_v2）。

    八、本政策的更新
    我们可能会不定期修改、更新本隐私政策，有关隐私政策的更新，我们会在共同照护中以通知公告等形式发布，您可以访问共同照护查询最新版本的隐私政策。对于重大变更，我们会向您发出郑重通知（包括对于某些服务，我们会通过短信发送通知，说明对隐私政策进行的更改）。

    九、适用范围
    1. 我们的隐私政策适用于由天津九安医疗电子股份有限公司及其关联公司提供的所有服务，包括共同照护及www.ihealthlabs.com.cn上提供的服务，但是不包括附有独立隐私政策的服务（如第三方提供的产品和服务）。
    2. 我们的隐私权政策不适用于第三方提供的产品和服务，例如在共同照护及www.ihealthlabs.com.cn上由第三方提供的产品和服务，以及在我们的服务中链接到的其他网站，这些产品、服务或网站会有独立的隐私政策予以规范，请另行查阅相应的政策规定。
    3. 对于为我们的服务进行广告宣传，以及可能使用我们的cookie或其他日志信息来投放和使用广告的其他公司和组织，我们的隐私权政策并未涵盖其信息处理政策。
    4. 本隐私政策的签订、生效、履行、争议的解决均适用中华人民共和国法律。
    5. 有关本协议的争议应通过友好协商解决，如果协商不成，该争议将提交公司所在地有管辖权的法院诉讼解决。\n`,
  }
  render() {
    return (
      <RootView>
        <TextContent
          dangerouslySetInnerHTML={{ __html: this.state.content }}
        ></TextContent>
      </RootView>
    )
  }
}

export default PrivacyAgreementJa

const RootView = styled.div`
  background-color: white;
  flex-direction: column;
  width: 100%;
  height: 100%;
`
const TextContent = styled.div`
  padding: 10px;
  white-space: pre-line;
`



// WEBPACK FOOTER //
// ./src/modules/activity/components/privacyAgreementJa.js